import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

const version = process.env.REACT_APP_VERSION || "dev";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    lowerCaseLng: true,
    supportedLngs: ["fr", "en"],
    fallbackLng: ["fr", "en"],
    returnObjects: true,
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${version}`
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng"
    },

    interpolation: { escapeValue: false }
  });

export default i18n;